import { useState, useEffect } from 'react';

/**
 * Hook to fetch conversion report from backend.
 *
 * Usage:
 *   const { report, loading, error } = useConversionReport(discoveredWorkflowId);
 */
export const useConversionReport = (discoveredWorkflowId) => {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!discoveredWorkflowId) {
      setReport(null);
      return;
    }

    const fetchReport = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `/api/v1/discovery/workflows/${discoveredWorkflowId}/conversion-report`
        );
        if (response.ok) {
          const data = await response.json();
          setReport(data.report);
        } else if (response.status === 404) {
          setReport(null); // No report yet
        } else {
          setError(`HTTP ${response.status}: ${response.statusText}`);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [discoveredWorkflowId]);

  return { report, loading, error };
};

export default useConversionReport;
